import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { useInputValue } from '../../hooks/useInputValue'
import Switch from 'react-switch'
import Select from 'react-select'
import './styles.scss'

export const CoursesForm = ({
  item,
  isLoading,
  usersList,
  usersListToEdit,
  usersListE,
  usersListEToEdit,
  laboratoryList,
  laboratoriesListToEdit,
  onSubmit,
  cancelLink,
  userLogged
}) => {
  const [checked, setChecked] = useState(item != null ? (item.status ? true : false) : false)
  const [selected, setSelected] = useState(usersListToEdit)
  const [selectedE, setSelectedE] = useState(usersListEToEdit)
  const [selectedLaboratory, setSelectedLaboratory] = useState(laboratoriesListToEdit)

  const [usersModified, setUsersModified] = useState(false)
  const [studentsModified, setStudentsModified] = useState(false)
  const [laboratoriesModified, setLaboratoriesModified] = useState(false)

  const { ...name } = useInputValue(
    {
      value: item ? item.name : '',
      name: 'name',
      type: 'text',
      required: true,
      disabled: isLoading,
    },
    false
  )

  const { ...version } = useInputValue(
    {
      value: item ? item.version : '',
      name: 'version',
      type: 'text',
      required: true,
      disabled: isLoading,
    },
    false
  )

  const handleChange = (nextChecked) => {
    setChecked(nextChecked)
  }

  const handleUserChange = (selectedOptions) => {
    setSelected(selectedOptions)
    setUsersModified(true)
  }

  const handleUserEChange = (selectedOptions) => {
    setSelectedE(selectedOptions)
    setStudentsModified(true)
  }

  const handleLaboratoryChange = (selectedOptions) => {
    setSelectedLaboratory(selectedOptions)
    setLaboratoriesModified(true)
  }

  const disableRolSelector = () => {
    if (userLogged === 'T') {
      return true;
    }

    return false;
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    let userv = []
    if (usersModified) {
      userv = selected.map(vselec => vselec.value)
    } else {
      userv = usersListToEdit.map(user => user.value)
    }

    let studentsv = []
    if (studentsModified) {
      studentsv = selectedE.map(vselece => vselece.value)
    } else {
      studentsv = usersListEToEdit.map(userE => userE.value)
    }

    const combinedUsers = [...userv, ...studentsv]

    let laboratories = []
    if (laboratoriesModified) {
      laboratories = selectedLaboratory.map(vselec => vselec.value)
    } else {
      laboratories = laboratoriesListToEdit.map(lab => lab.value)
    }

    const data = {
      users: combinedUsers,
      name: name.value,
      version: version.value,
      status: checked,
      laboratories: laboratories,
    }

    onSubmit(data)
  }

  return (
    <div className="form-container">
      <form disabled={isLoading} onSubmit={handleSubmit}>

        <div className="form-group">
          <label htmlFor="name-input">Nombre {name.required ? '*' : ''} </label>
          <InputText id="name-input" {...name} />
        </div>

        <div className="form-group">
          <label htmlFor="version-input">Versión {version.required ? '*' : ''}</label>
          <InputText id="version-input" {...version} />
        </div>

        <div className="form-group">
          <label htmlFor="type-input">Asignar profesor(es) {name.required ? '*' : ''}</label>
          <Select
            defaultValue={usersListToEdit}
            isMulti
            name="user"
            options={usersList}
            className="basic-multi-select"
            id="user"
            classNamePrefix= "select"
            onChange= {handleUserChange}
            isDisabled= {disableRolSelector()}
          />
        </div>

        <div className="form-group">
          <label htmlFor="type-input">Asignar estudiante(s) {name.required ? '*' : ''}</label>
          <Select
            defaultValue={usersListEToEdit}
            isMulti
            name="usere"
            options={usersListE}
            className="basic-multi-select"
            id="usere"
            classNamePrefix="select"
            onChange={handleUserEChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="laboratory-input">Asignar Laboratorios {name.required ? '*' : ''}</label>
          <Select
            defaultValue={laboratoriesListToEdit}
            isMulti
            name="laboratory"
            options={laboratoryList}
            className="basic-multi-select"
            id="laboratory"
            classNamePrefix="select"
            onChange={handleLaboratoryChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="status-input">Estado </label>
          <div className="swcomponent">
            <Switch onChange={handleChange} checked={checked} className="react-switch" />
          </div>
        </div>

        <div className="button-group">
          <Button
            label={isLoading ? 'Guardando...' : 'Guardar'}
            disabled={isLoading}
            type="submit"
            className="button primary"
          />
          <Link to={cancelLink} className="button secondary">
            Cancelar
          </Link>
        </div>
      </form>
    </div>
  )
}

CoursesForm.propTypes = {
  item: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  usersList: PropTypes.array.isRequired,
  usersListToEdit: PropTypes.array.isRequired,
  usersListE: PropTypes.array.isRequired,
  usersListEToEdit: PropTypes.array.isRequired,
  laboratoryList: PropTypes.array.isRequired,
  laboratoriesListToEdit: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  cancelLink: PropTypes.string.isRequired,
}
